module.exports = __webpack_public_path__ + "img/372f0.84e5e5c2.svg";